<template>
    <v-container>
        <v-snackbar v-model="alert" timeout="5000" :color="alertType">
            {{ alertContent }}
        </v-snackbar>
        <v-card style="margin-bottom:10px">
            <v-card-title>
                {{$t('tasks')}}
                <v-spacer></v-spacer>
                <v-btn color="primary" outlined to="/tasks/new">
                    <v-icon small>mdi-plus</v-icon>{{$t('createNewTask')}}
                </v-btn>
            </v-card-title>
        </v-card>
        <v-data-table :headers="headers" :items="tasks" :items-per-page="-1" class="elevation-1">
            <template v-slot:item="{ item }">
                <tr>
                    <td @click="editTask(item)">{{ item.id }}</td>
                    <td @click="editTask(item)">{{ item.description }}</td>
                    <td @click="editTask(item)">{{ item.type }}</td>
                    <td @click="editTask(item)">{{ item.createTs }}</td>
                    <td @click="editTask(item)">{{ item.status }}</td>
                    <td @click="editTask(item)">{{ item.active }}</td>
                    <td @click="editTask(item)">{{ item.sendMailInEnd }}</td>
                    <td @click="editTask(item)">{{ item.sendMailInError }}</td>
                    <td @click="editTask(item)">{{ item.nextRun }}</td>
                    <td>
                        <v-btn icon @click="logTask(item)">
                            <v-icon>
                                mdi-chart-box
                            </v-icon>
                        </v-btn>
                        <v-btn icon @click="deleteTask(item)">
                            <v-icon>
                                mdi-delete
                            </v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-container>
</template>
<script>
import axios from 'axios';
export default {
    data: () => ({
        alert: false,
        alertType: 'primary',
        alertContent: '',
        tasks: [

        ],
    }),
    computed: {
        headers () {
            return [
                {
                    text: '#',
                    align: 'start',
                    sortable: false,
                    value: 'id'
                },
                { text: this.$t('description'), value: 'description' },
                { text: this.$t('type'), value: 'type' },
                { text: this.$t('createTime'), value: 'createTs' },
                { text: this.$t('status'), value: 'status' },
                { text: this.$t('active'), value: 'active' },
                { text: this.$t('mailInSuccess'), value: 'sendMailInEnd' },
                { text: this.$t('mailInError'), value: 'sendMailInError' },
                { text: this.$t('nextRunTime'), value: 'nextRun' },
                { text: this.$t('actions'), value: 'actions', sortable: false },
            ]
        }
    },
    methods: {
        loadData () {
            (async () => {
                const body = { token: sessionStorage.token, limit: "99999"};
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetTasks`, body);
                this.tasks = response.data.tasks;
                const types = {
                    RunTzintuk: this.$t('runTzintuk'),
                    SendSMS: this.$t('sendSms'),
                }
                for (let task of this.tasks) {
                    task.type = types[task.type] || task.type;
                }
                const status = {
                    PENDING: this.$t('pending'),
                    NOT_ACTIVE: this.$t('notActive'),
                    END: this.$t('end'),
                    ERROR: this.$t('error')
                }
                for (let task of this.tasks) {
                    task.status = status[task.status] || task.status;
                }
                const boolean = {
                    1: this.$t('yes'),
                    0: this.$t('no')
                }
                for (let task of this.tasks) {
                    task.active = boolean[task.active] || task.active;
                    task.sendMailInEnd = boolean[task.sendMailInEnd] || task.sendMailInEnd;
                    task.sendMailInError = boolean[task.sendMailInError] || task.sendMailInError;
                }
            })();
        },
        editTask (item) {
            this.$router.push(`/tasks/edit/${item.id}`)
        },
        deleteTask (item) {
            (async () => {
                const body = { token: sessionStorage.token, TaskId: item.id};
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/DeleteTask`, body);
                if(response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = `${this.$t('taskNumber')} ${item.id} ${this.$t('deleteSuccess')}`;
                    setTimeout(this.loadData(), 1000)
                }
                else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('errorInDeleteTask')
                }
            })();
        },
        logTask (item) {
            this.$router.push(`/tasks/log/${item.id}`)
        },
    },
    beforeMount() {
        this.loadData();
    },
}
</script>
<style scoped>
tr {
    cursor: pointer;
}
</style>